// extracted by mini-css-extract-plugin
module.exports = {"card":"unitCard_card__3U3ir","swiperContainer":"unitCard_swiperContainer__1Ij9i","image":"unitCard_image__3K2HA","tag":"unitCard_tag__1OTZ7","title":"unitCard_title__1URMD","price":"unitCard_price__3HfUt","priceForDashboard":"unitCard_priceForDashboard__3NPu6","from":"unitCard_from__DYckt","fromForDashboard":"unitCard_fromForDashboard__1oa_n","isEditable":"unitCard_isEditable__3PY3r"};
    if(module.hot) {
      // 1745908321990
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  